// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"_3iFaJ","cardTitle":"_39S_p","cardItem":"FoJFy","cardItemTitle":"D1QAU","cardItemValue":"_2tU2L"};